import _ from 'lodash';
import DataProvider from '../app/data-framework/data-provider';
import Api from './api.js';
import FilterMigrationService from './filter.migration.service.js';
import Query from './models/query.model';

const ONE_SECOND_IN_MILLIS = 1000;
const THIRTY_SECONDS_IN_MILLIS = 30 * ONE_SECOND_IN_MILLIS;

export default class DataService {
  constructor() {}

  static init() {
    DataService.panelCallbackRegistry = {};
    DataService.queryRegistry = new Map();
  }

  static restartRequests() {
    // If there is an existing timer, clear it
    clearTimeout(DataService.timer);
    // give time for other panels to register then request data
    DataService.timer = setTimeout(() => {
      DataService.requestData();
    }, 50);
  }

  static requestData() {
    // clear out timer if there is one
    clearTimeout(DataService.timer);
    // todo: optimize if there are multiple panels with the same query
    DataService.queryRegistry.forEach((query, panelId) => {
        executeQuery(query).then(response => {
            let callback =  DataService.panelCallbackRegistry[panelId];
            if (callback) {
              callback(response.data.results);
            }
        });
    });
    // DataService.timer = setTimeout(() => DataService.requestData, THIRTY_SECONDS_IN_MILLIS); // CPMA data doesn't need polling, maybe need to add this back for CPMM
  }

  static registerPanel(panel, filters, dateRange, callback) {
    if (!DataService.panelCallbackRegistry) {
        DataService.init();
    }
    DataService.panelCallbackRegistry[panel.id] = callback;
    let query = getQueryForPanel(panel, filters, dateRange);
    DataService.queryRegistry.set(panel.id, query);
    this.restartRequests();
  }

  static deregisterPanel(panel) {
    delete DataService.panelCallbackRegistry[panel.id];
    DataService.queryRegistry.delete(panel.id);
  }
}

function getQueryForPanel(panel, filters, dateRange) {
  let query = new Query(panel, filters, dateRange);
  return query;
}
function executeQuery(query) {
    let filters = query.filters.getActiveFiltersForQuery();
    let filterParam = FilterMigrationService.migrateFilterExpressionToApiFilter(filters);
    
    let params = {'data': {
            aggregateFact: query.aggregateFact,
            dataset: query.dataset,
            groupBy: query.groupBy,
            sort: query.sort,
            start: query.dateRange.startDate.format('YYYY-MM-DD'),
            end: query.dateRange.endDate.format('YYYY-MM-DD'),
            groupAlias: 'name',
            valueAlias: 'y'
        }
    };

    if (!_.isEmpty(filterParam) && !query.filters.isEmpty()) {
      params['data'].filter = filterParam;
    }


    return DataProvider.getInstance().fetchAssuranceDashboardServiceBaseURL().then(baseUrl => {
      return Api.request({
        url: baseUrl + '/chart/named',
        method: 'POST',
        responseType: 'json',
        data: params,
      })
      .then(response => response.data) // not sure what this does
      .then(response => { // hack to remove bad empty data
        if (response.data && response.data.results && response.data.results.length === 1) { 
          if( Object.keys(response.data.results[0]).length === 0 || Object.values(response.data.results[0]).every(value => value === null || value === 0)) {
            response.data.results = [];
          }
        }
        return response;
      })
      .catch(error => {
        console.error('Failed Request', error);
        throw error;
      });
    });
}
